import { useState, useImperativeHandle, forwardRef, useRef, React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const TimeInput = forwardRef((props, ref) => {
	const { className, placeholder, type } = props;
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function handleChange(e) {
		// 입력값에서 숫자만 추출해 HH:MM-HH:MM 형식으로 결정적으로 재조립 //
		// 구분자(:, -)는 입력값에서 무시하고 숫자 위치 기준으로만 삽입하므로 //
		// 구분자 직접입력·중간편집·붙여넣기로도 깨진 문자열이 만들어지지 않는다 //
		const digits = e.target.value.replace(/[^0-9]/g, '').slice(0, 8);

		let formatted = digits.slice(0, 2);

		if (digits.length > 2) formatted += ':' + digits.slice(2, 4);
		if (digits.length > 4) formatted += '-' + digits.slice(4, 6);
		if (digits.length > 6) formatted += ':' + digits.slice(6, 8);

		setValue(formatted);
	
		setChanged(true);
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return <Input
		ref={inputRef}
		clickCount={clickCount}
		type={type}
		placeholder={defaultPlaceholder}
		value={value}
		changedColor={changedPlaceholderColor}
		className={`${className} ${changed ? "changed" : ""}`}
		onClick={handleClick}
		onChange={handleChange}
		onFocus={handleFocus}
		onBlur={handleBlur}/>
});

export default TimeInput;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  margin: 8px 0 0 0;
  padding: 0px 10px;

  width: 288px;
  height: 30px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
	color: ${props => props.theme.text};

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
	}

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-track {
		background-color: ${props => props.theme.subBackground};
	}
	
  transition: all 0.3s ease-in-out;
`;